import { DomParser as domParser } from '@thednp/domparser';

export function checklistProgress(htmlString: string): { total: number; partNumber: number } | undefined {
  if (htmlString.includes('taskList')) {
    const html =
      '<!DOCTYPE html><html lang="en"><head><title>title</title></head><body>' + htmlString.trim() + '</body></html>';
    const doc = domParser().parseFromString(html).root;
    const uls = doc.getElementsByTagName('ul');
    if (uls.length > 0) {
      const result = { total: 0, partNumber: 0 };
      uls.forEach((ul) => {
        if (ul.getAttribute('data-type') === 'taskList') {
          const lis = ul.getElementsByTagName('li');
          lis.forEach((li) => {
            result.total++;
            if (li.getAttribute('data-checked') === 'true') {
              result.partNumber++;
            }
          });
        }
      });
      return result;
    }
  }
}
